<template>
  <main class="wrapper">
    <section
      id="section-logo-nitro"
      class="bg-transparent"
    >
      <div
        id="container-logo-nitro"
        class="p-4"
      >
        <img
          id="icon"
          src="/images/logo_nitro_mobile.svg"
          alt="Logo Nitro"
        >
      </div>
    </section>
    <section id="section-form">
      <v-form
        id="form"
        ref="form"
      >
        <v-text-field
          v-model="form.email"
          label="Email"
          required
        />
        <v-text-field
          v-model="form.password"
          label="Senha"
          required
          :append-icon="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"
          :type="showPassword ? 'text' : 'password'"
        />

        <div class="d-flex justify-content-center">
          <v-btn
            color="nitro"
            class="w-100 white--text"
            @click="onSubmit"
          >
            Entrar
          </v-btn>
        </div>
      </v-form>
    </section>
  </main>
</template>
<script>
import { redirect } from '@/utils/misc'
export default {
    data(){
        return {
            form : {
                email: '',
                password: '',
            },
            rules: {
              required: value => !!value || 'Required.',
            },
            showPassword: false,
            emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
        }
    },
    methods: {
      login(data){
        return axios.post(`/login`, data)
      },
      onSubmit(){
        this.login(this.form)
        .then(()=> {
          redirect('/')
        })
        .catch((e) => {
            this.$notify({
                type: 'error',
                text: 'Erro ao realizar o login'
            })
            return e
        })
      }
    }
}
</script>
<style lang="scss" scoped>

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        min-height: 100vh;
        padding: 20px;
        background: linear-gradient(to right, #060181, #F74A4B) !important;
    }

    #section-logo-nitro, #section-form {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 430px;
        min-height: 100%;
    }

    #container-logo-nitro{
        height: 212px;
        > img {
            width: 100%;
            height: 100%;
        }
    }

    @media screen and (max-width: 1000px) {
        .wrapper{
            flex-direction: column;
            justify-content: center;
        }
    }

    @media screen and (max-width: 767px) {
        #section-form, #section-logo-nitro{
            width: 300px;
        }
    }

    @media screen and (max-width: 600px) {
        #section-form, #section-logo-nitro{
            width: 283.83px;
        }
    }

    @media screen and (max-width: 314px) {
        #section-form, #section-logo-nitro{
            width: 80vw;
        }
    }
</style>
